<table mat-table [dataSource]="dataSource" matSort matSortStart="desc" (matSortChange)="sortData($event)">
  <ng-container [matColumnDef]="column.value" *ngFor="let column of columns; let colIndex = index">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="{{ column.value }}"
      [disabled]="column.value === 'projectTeam'" [ngClass]="{ 'project-status-col': column.value === 'status' }">
      {{ column.label }}
    </th>
    <td mat-cell *matCellDef="let element">
      <!-- Status chip -->
      <span *ngIf="column.value === 'status'">
        <div class="status-container">
          <!-- Tooltip applied on the tag (host element of the component). -->
          <app-tag class="tooltip-host" [title]="element[column.value]" [matTooltip]="element[column.value]"
            matTooltipPosition="above" matTooltipClass="lengthy-tooltip">
          </app-tag>

          <mat-icon class="refresh-icon" *ngIf="element[column.value] === projectStatusEnum.CREATED.toString()
               && element.fabricWorkspaceConfigured
               && element.doesFabricJobExist
               && !element.isFabricJobCompleted" (click)="checkFabricJobStatus(element)">
            refresh
          </mat-icon>
        </div>
      </span>

      <!-- Project title link with tooltip -->
      <span *ngIf="column.value === 'projectTitle'" class="tooltip-host">
        <a class="remove-underline tooltip-anchor" [matTooltip]="element[column.value]" matTooltipPosition="above"
          matTooltipClass="lengthy-tooltip" (click)="openProjectSettingsPage(element)">
          {{ element[column.value] }}
        </a>
      </span>

      <!-- Solution offering (fallback text when empty) -->
      <span *ngIf="column.value === 'solutionOffering'" class="tooltip-host"
        [matTooltip]="element[column.value] === '' ? 'Awaiting configuration' : element[column.value]"
        matTooltipPosition="above" matTooltipClass="lengthy-tooltip">
        {{ element[column.value] === '' ? 'Awaiting configuration' : element[column.value] }}
      </span>

      <!-- Generic text columns -->
      <span *ngIf="
      column.value !== 'status' &&
      column.value !== 'projectTeam' &&
      column.value !== 'projectTitle' &&
      column.value !== 'solutionOffering'
    " class="tooltip-host" [matTooltip]="element[column.value]" matTooltipPosition="above"
        matTooltipClass="lengthy-tooltip">
        {{ element[column.value] }}
      </span>

      <!-- Avatars -->
      <span class="avatar-area" *ngIf="column.value === 'projectTeam'">
        <app-stacked-user-avatars [users]="element[column.value]" [cramped]="true" [gridView]="true">
        </app-stacked-user-avatars>
      </span>
    </td>
  </ng-container>

  <!--3 vertical dots-->
  <ng-container matColumnDef="Action">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let project" class="align-right">
      <div>
        <button mat-icon-button [matMenuTriggerFor]="projectConfigMenu.menu">
          <mat-icon class="dot-menu-icon">more_vert</mat-icon>
        </button>
        <app-project-config-menu #projectConfigMenu="projectConfigMenu" [project]="project"></app-project-config-menu>
      </div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<app-numbered-navigation [index]="currentPageIndex" [totalCount]="totalProjectsCount" [pageSize]="defaultPageSize">
</app-numbered-navigation>